import CustomTooltip from '@/components/ToolTip/CustomTooltip';
import { getBreakForModel } from '@/pages/AdvancedEditor/utils/breakConversion';
import { IVoice, Providers } from '@d-id/types';
import styled from '@emotion/styled';
import { Player } from '@lottiefiles/react-lottie-player';
import { useMemo, useState } from 'react';
import Stopwatch from './images/Stopwatch.svg';
import StopwatchAnimation from './images/StopwatchAnimation.json';
import StopwatchDisabled from './images/StopwatchDisabled.svg';

const StopwatchIcon = styled.img`
    display: flex;
    height: 2rem;
    width: 2rem;
`;

const StopWatchPlayer = styled(Player)`
    height: 2rem;
    width: 2rem;
`;

const AddBreakButton = styled.button`
    display: flex;
    margin-left: 1.5rem;
    align-items: center;
    cursor: pointer;
    background: transparent;
    border: none;
    font-size: 1.33333rem;
    font-weight: 400;
    line-height: 100%;
    color: #000000de;
    padding: 0;

    :disabled {
        cursor: default;
        color: #9a9a9a;
    }
`;

interface Props {
    cursorPosition: number;
    disabled: boolean;
    text: string;
    setText: (value: string) => void;
    ttsSelectedVoice: IVoice | null;
}

export const AddBreak = ({ cursorPosition, disabled, text, setText, ttsSelectedVoice }: Props) => {
    const [isAnimated, setIsAnimated] = useState(false);
    const validVoice = ttsSelectedVoice?.provider !== Providers.Amazon;
    const isDisabled = disabled || !validVoice;

    const modelId = ttsSelectedVoice?.provider === Providers.Elevenlabs ? ttsSelectedVoice?.config?.modelId : undefined;
    const breakString = getBreakForModel(modelId);

    const tooltipText = useMemo(() => {
        if (!validVoice) {
            return "Breaks aren't available for this voice";
        }

        return 'Add a 0.5s break';
    }, [validVoice]);

    function addBreak() {
        setIsAnimated(true);
        setText(text.substring(0, cursorPosition) + ' ' + breakString + text.substring(cursorPosition));
    }
    return (
        <CustomTooltip
            title={tooltipText}
            placement="top"
            containerWidth="5rem"
            containerHeight="2rem"
            cursor="pointer"
            onClick={addBreak}
            disabled={isDisabled}>
            <AddBreakButton disabled={isDisabled} id="break">
                {isAnimated ? (
                    <StopWatchPlayer src={StopwatchAnimation} autoplay onEvent={event => event === 'complete' && setIsAnimated(false)} />
                ) : (
                    <StopwatchIcon src={isDisabled ? StopwatchDisabled : Stopwatch} />
                )}
            </AddBreakButton>
        </CustomTooltip>
    );
};
